<template>
    <div tabindex="-1" role="dialog" class="modal modal-new-widget in modal-schedule-publishing" v-show="isVisible">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" @click="closeModal">&times;</button>
                    <h4 class="modal-title">
                        <i class="fal fa-clock"></i><span>{{ $t('admin.schedulePublishing') }}</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div style="padding: 20px; width: 100%; text-align: left">
                        <div class="form-group reduced-bottom-margin">
                            <label>{{ $t('admin.selectScheduleDate') }}</label>
                            <date-time-field
                                v-on:change="onPublishChange"
                                :id="'published_at'"
                                :field-type="'DateTime'"
                                :label="'Select a date'"
                                :name="'published_at'"
                                :value="getObjectPropertyValueByPath(admin, 'editedEntry.system.published_at')"
                            ></date-time-field>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="closeModal">
                        {{ $t('admin.close') }}
                    </button>
                    <button type="button" class="btn btn-danger" @click="onSubmit">
                        {{ $t('admin.saveChanges') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-backdrop in"></div>
    </div>
</template>

<script>
import SchedulePublishingModal from './SchedulePublishingModal.js';
export default SchedulePublishingModal;
</script>

<style>
.modal-schedule-publishing {
    display: block;
}
.modal-dialog {
    z-index: 1050;
}
</style>
